import React from 'react';
import { FileTextIcon, LockIcon, PackageXIcon, ShieldCheckIcon, UsersIcon, WalletIcon } from 'lucide-react';
import { offer, productFacts } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const badges = [{
  icon: FileTextIcon,
  label: 'Formato PDF digital'
}, {
  icon: WalletIcon,
  label: 'Pago único'
}, {
  icon: UsersIcon,
  label: 'Para hombres y mujeres'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: PackageXIcon,
  label: 'Sin envíos físicos'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-mint-50" data-id="element-136" data-mp="s9q7jpfyirex">
      <div className="mx-auto max-w-6xl px-6 pb-16 pt-14 sm:pt-20" data-id="element-137" data-mp="ncq0pcba9kmr">
        <div className="grid items-center gap-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-16" data-id="element-138" data-mp="nekmesudpgrw">
          <div data-id="element-139" data-mp="382fgpsnq3ch1">
            <Reveal data-id="element-140" data-mp="381xn73sg3cct">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-mint-700" data-id="element-141" data-mp="381e0l9runzsg">
                Naturia · Megapack Salud Plena
              </p>
              <h1 className="mt-5 font-display text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-142" data-mp="3o7lq5lizewmb">
                Ordena tu alimentación y tus hábitos digestivos
                <span className="block text-mint-700" data-id="element-143" data-mp="39a32ynlycrgz">con una ruta guiada de 15 días.</span>
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-144" data-mp="3ebioegs1kzzw">
                Material educativo en PDF para entender mejor tu digestión,
                organizar tus comidas y crear hábitos sostenibles. Sin dietas
                extremas y sin necesidad de saber cocinar.
              </p>
            </Reveal>

            <Reveal delay={0.06} data-id="element-145" data-mp="2vi55ja1lsk0n">
              <ul className="mt-8 flex flex-wrap items-center gap-2.5" data-id="element-146" data-mp="2vj7tpa7jk8cv">
                {badges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-3.5 py-2 text-sm font-medium text-ink-soft ring-1 ring-inset ring-mint-200" data-id="element-147" data-mp="2hjox9eo3elge">
                    <badge.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-148" data-mp="s3ckw8bgjfpi" />
                    {badge.label}
                  </li>)}
              </ul>

              <div className="mt-8" data-id="element-149" data-mp="ibgn6yda9rlt">
                <CtaButton data-id="element-150" data-mp="ichyn3y7og42">{offer.ctaPrimary}</CtaButton>
              </div>

              <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-151" data-mp="degfkj0scgsl">
                {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-152" data-mp="1b15lh3ylzdjq">
                    <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-153" data-mp="162c7zbjbnmjk" />
                    {item.label}
                  </li>)}
              </ul>
            </Reveal>
          </div>

          <figure className="flex flex-col items-center" data-id="element-154" data-mp="x0l50eg61tte">
            <img src="https://cdn.magicpatterns.com/uploads/4ASVY3GgLjwPr6cLHNRnfP/e45b6f76-3e8d-430f-ac26-e60c5700a057.webp" alt="Portadas de los 6 tomos del Megapack Salud Plena" className="w-full rounded-3xl bg-mint-100 object-cover shadow-lift" width={1200} height={900} loading="eager" decoding="async" fetchPriority="high" style={{
            objectFit: "cover",
            width: "327px",
            height: "502px"
          }} data-id="element-155" data-mp="3ltgltmwy8kmr" />
            <figcaption className="mt-4 max-w-[327px] text-center text-xs leading-relaxed text-ink-muted" data-id="element-156" data-mp="268g282sk4mmm">
              Imagen ilustrativa. El Megapack se entrega en archivos PDF; no se
              envían libros físicos.
            </figcaption>
          </figure>
        </div>

        <Reveal delay={0.05} data-id="element-157" data-mp="2kxudjgfp1e4n">
          <dl className="mt-16 grid gap-px overflow-hidden rounded-2xl bg-mint-200 sm:grid-cols-2 lg:grid-cols-4" data-id="element-158" data-mp="2kx2hk4i6pedu">
            {productFacts.map(fact => <div key={fact.label} className="flex flex-col bg-white px-6 py-6" data-id="element-159" data-mp="2tzbsgvhd79rr">
                <dt className="text-sm text-ink-muted" data-id="element-160" data-mp="umhdeaf58hnt">{fact.label}</dt>
                <dd className="mt-1 font-display text-2xl text-ink" data-id="element-161" data-mp="uoak1pprb1vt">{fact.value}</dd>
                <dd className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-162" data-mp="zm2n9fvuqafb">{fact.detail}</dd>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </header>;
}